import {
  Link,
  withRouter,
  RouteComponentProps,
  useHistory,
  useLocation,
  useRouteMatch,
  useParams
} from 'react-router-dom';

export type RouterTypes = RouteComponentProps;

export default {
  Link,
  withRouter,
  useHistory,
  useLocation,
  useRouteMatch,
  useParams
};
